function networkType(network?: string) {

    let networkIcon = ''
    switch (network) {
        case 'usdc':
            networkIcon = '/usdc.png';
            break;
        case 'tether':
            networkIcon = '/usdt.png';
            break;
        case 'apecoin':
            networkIcon = '/app.png';
            break;
        case 'bitcoin':
            networkIcon = '/btc.png';
            break;
        case 'polygon':
            networkIcon = '/matic.png';
            break;
        case 'dogecoin':
            networkIcon = '/doge.png';
            break;
        case 'ethereum':
            networkIcon = '/eth.png';
            break;
        case 'litecoin':
            networkIcon = '/ltc.png';
            break;
        case 'shibainu':
            networkIcon = '/shib.png';
            break;
        case 'bitcoincash':
            networkIcon = '/bch.png';
            break;
        case 'coinpulse':
                networkIcon = '/cpoLight.png';
                break;
        default:
            break;
    }

    return networkIcon
}

export { networkType }